import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {getMonthNameById } from '../services/MyCollections';
import { green } from '@mui/material/colors';

export default function GenerateInvoiceDialog({ open, handleClose, handleCreateInvoices, month, year}) {

    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef();

    const buttonSx = {
        ...(success && {
          bgcolor: green[500],
          '&:hover': {
            bgcolor: green[700],
          },
        }),
      };
    
      React.useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
      }, []);

      React.useEffect(() => {
        if (open) {
          setSuccess(false); // resetowanie stanu success przy otwarciu dialogu
        }
      }, [open]);
    
      const handleButtonClick = async () => {
        if (!loading) {
          setSuccess(false);
          setLoading(true);
          await handleCreateInvoices();
          setSuccess(true);
          setLoading(false);
        }
      };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Generowanie faktur w fakturowania.pl"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Czy potwierdzasz, że chcesz wygenerować faktury za <strong>{getMonthNameById(month)} {year}</strong> dla zaznaczonych podmiotów?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" variant="outlined" onClick={handleClose}>Anuluj</Button>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ m: 2, position: 'relative' }}>
                            <Button
                                variant="contained"
                                sx={buttonSx}
                                disabled={loading}
                                onClick={handleButtonClick}
                            >
                                Generuj Faktury
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                        <Box sx={{ m: 2, position: 'relative' }}>
                            <Fab
                                aria-label="save"
                                color="primary"
                                sx={buttonSx}
                                onClick={handleButtonClick}
                            >
                                {success ? <CheckIcon /> : <SaveIcon />}
                            </Fab>
                            {loading && (
                                <CircularProgress
                                    size={68}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: -6,
                                        left: -6,
                                        zIndex: 1,
                                    }}
                                />
                            )}
                        </Box>
                    </Box> 

                </DialogActions>
            </Dialog>
        </div>
    );
}